/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/footer/app.footer.component.ts.
 */
import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppConfigService} from '../../services/app.config.service';
import {AppLieferkundeService} from '../../services/app.lieferkunde.service';
import {AppMobileService} from '../../services/app.mobile.service';
import {AppPrivacyService} from '../../services/app.privacy.service';
import {BehaviorSubject, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DomainConfig} from '../../models/domain-config';
import {Lieferkunde} from '../../models/lieferkunde';
import {AppNavbarService} from '../../services/app.navbar.service';

/**
 * Zweck: Beschreibt class AppFooterComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'app-footer',
    templateUrl: 'app.footer.component.html',
    styleUrls: ['app.footer.component.scss'],
    standalone: false
})
export class AppFooterComponent implements OnInit, OnDestroy {
  appVersion: number;

  isMobile = new BehaviorSubject(false);
  currentLieferkunde = new BehaviorSubject<Lieferkunde>(null);

  _destroy = new Subject();

  domainConfig: DomainConfig;

  disabled = new BehaviorSubject<boolean>(false);

  mobileShowLinks = new BehaviorSubject<boolean>(false);

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private cfg: AppConfigService, private lksvc: AppLieferkundeService, private msvc: AppMobileService,
              private psvc: AppPrivacyService, private nbsvc: AppNavbarService) {
    this.appVersion = cfg.getVersion();
  }

/**
 * Beschreibt Methode openPrivacySettings und ihren Rückgabevertrag.
 */
  openPrivacySettings() {
    this.psvc.openDialog();
  }

/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
    this._destroy.next(true);
    this._destroy.complete();
  }

/**
 * Beschreibt Methode showMobileLinks und ihren Rückgabevertrag.
 */
  showMobileLinks() {
    this.mobileShowLinks.next(true);
    setTimeout(() => {
      this.mobileShowLinks.next(false);
    }, 5000);
  }

/**
 * Beschreibt Methode hideMobileLinks und ihren Rückgabevertrag.
 */
  hideMobileLinks() {
    this.mobileShowLinks.next(false);
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.domainConfig = this.cfg.domainconfig;

    this.nbsvc.disabled$
      .pipe(takeUntil(this._destroy))
      .subscribe(d => this.disabled.next(d));

    this.lksvc.current_lieferkunde$
      .pipe(takeUntil(this._destroy))
      .subscribe(lk => this.currentLieferkunde.next(lk));

    this.msvc.isMobile()
      .pipe(takeUntil(this._destroy))
      .subscribe(m => {
        this.isMobile.next(m);
      });
  }


}
